export const NOT_FOUND = '@@redux-first-router/NOT_FOUND';
export const ADD_ROUTES = '@@redux-first-router/ADD_ROUTES';